import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import dojoDate from 'dojo/date';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import MultiSelect from '../../../moreCore/UI/Multiselect/Multiselect';
import template from './CateringBookingForm.html?raw';

// create() calls nest create()-results as parents — alias dom-construct to any. Behaviour unchanged.
const domConstruct: any = domConstructTyped;

// NOTE (JS2TS): dropped dead deps (imported in the original define() but unused in code &
// template): dojo/aspect, dojo/number.
// NOTE (JS2TS): the local/parameter name `package` in the original is a reserved word in
// strict-mode modules, so it is transcribed as `pkg` in every scope it appears
// (_onChangePackageCounter, _onClickDeleteTableButton, drawPackagesTable,
// buildCateringPackagesRegistry, CreateAndFillBookingEntity). Behaviour is unchanged.

class CateringBookingForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    entityGUID: any = null;
    jsonEntity: any = null; // Entity wies aus der Datenbank kommt
    bookingEntity: any = null;
    isDirty = false;
    _formDataUndirty: any = null;
    cateringPackagesData: any = [];
    filteredCateringPackagesData: any = [];
    cateringPackagesMusliSelect: any = null;
    cateringPackagesMusliSelectSingle: any = null;
    serializedData: any = null;
    valueBookingAddress: any = null;
    //valueCoverCheck: "yes",

    readonly = false;

    saveAsTemplate = false;
    isFromTemplate = false;

    // Objekt mit Werten die beim Speichern übergeben werden (live / immer aktuell)
    formData: any = {
        isNewBooking: true,
        bookingId: null,
        telephone: null,
        email: null,
        costCenter: null,
        coNumber: "",
        orderLocationCatering: null,
        addressCheckValue: null,
        ownBookingAddress: "",
        bookedRoomAddress: null,
        personAmount: 0,
        /*coverCheckValue: null,*/
        cateringOccasion: null,
        cateringOccasionOther: "",
        bookingDate: null,
        bookingTimeStart: null,
        bookingTimeEnd: null,
        cateringPackages: [],
        specialRequest: null
    };

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate() {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;

        this.StandbyStart();
        //this._loadCateringPackagesList();

        domClass.add(this.inputCostCenre.input, "mds-bg-light-gray");

        //this.getDefaultUserDataValues();

        //LOAD LIST VALUES
        this.inputOrderLocation._loadListValues();
        //this.inputBookingBookedRoomAddress._loadListValues();
        this.inputCateringOccasion._loadListValues();
        //this.inputCateringPackagesList._loadListValues();

        this.inputCateringBookingTemplate._loadListValues();

        this.SetMinMaxBookingDate();
    }
    startup(bReload?: any) {
        super.startup.apply(this, arguments as any);

    }

    SetMinMaxBookingDate() {

        let date = new Date();
        date.setDate(date.getDate() + 2);

        let minDateString = date.toLocaleDateString('en-ca');
        domAttr.set(this.inputCateringBookingDate, "min", minDateString);

        date.setDate(date.getDate() + 182500);

        let MaxDateString = date.toLocaleDateString('en-ca');
        domAttr.set(this.inputCateringBookingDate, "max", MaxDateString);
    }

    _setReadonlyAttr(value: any) {
        if (value != true && value != false) {
            value = this.readonly;
        }
        this.readonly = value;
        //console.log("setreadonly", value);

        if (this.readonly) {

            domClass.add(this.inputPersonOrderingPhone, "w3-disabled");
            domClass.add(this.inputPersonOrderingMail, "w3-disabled");
            this.inputCostCenre._setReadonlyAttr(true);
            domClass.add(this.inputCoNumber, "w3-disabled");
            domClass.add(this.radioInputOwnRoom, "w3-disabled");
            domClass.add(this.radioInputBookedRoom, "w3-disabled");
            domClass.add(this.inputBookingOwnRoomAddress, "w3-disabled");
            domClass.add(this.inputPersonAmount, "w3-disabled");
            //domClass.add(this.radioInputYes, "w3-disabled");
            //domClass.add(this.radioInputNo, "w3-disabled");
            domClass.add(this.inputCateringBookingDate, "w3-disabled");
            domClass.add(this.inputCateringBookingTimeStart, "w3-disabled");
            domClass.add(this.inputCateringBookingTimeEnd, "w3-disabled");
            domClass.add(this.sectionCateringPackages, "w3-disabled");
            domClass.add(this.inputSpecialRequest, "w3-disabled");

            this.inputOrderLocation.set("readonly", true);
            this.inputBookingBookedRoomAddress.set("readonly", true);
            this.inputCateringOccasion.set("readonly", true);
            domClass.add(this.inputCateringOccasionOther, "w3-disabled");

            domClass.add(this.btn_submitBooking, "w3-disabled");
        } else {

            domClass.remove(this.inputPersonOrderingPhone, "w3-disabled");
            domClass.remove(this.inputPersonOrderingMail, "w3-disabled");
            //this.inputCostCenre._setReadonlyAttr(false);
            //domClass.remove(this.inputCoNumber, "w3-disabled");
            domClass.remove(this.radioInputOwnRoom, "w3-disabled");
            domClass.remove(this.radioInputBookedRoom, "w3-disabled");
            domClass.remove(this.inputBookingOwnRoomAddress, "w3-disabled");
            domClass.remove(this.inputPersonAmount, "w3-disabled");
            //domClass.remove(this.radioInputYes, "w3-disabled");
            //domClass.remove(this.radioInputNo, "w3-disabled");inputSpecialRequest
            domClass.remove(this.inputCateringBookingDate, "w3-disabled");
            domClass.remove(this.inputCateringBookingTimeStart, "w3-disabled");
            domClass.remove(this.inputCateringBookingTimeEnd, "w3-disabled");
            domClass.remove(this.sectionCateringPackages, "w3-disabled");
            domClass.remove(this.inputSpecialRequest, "w3-disabled");

            this.inputOrderLocation.set("readonly", false);
            this.inputBookingBookedRoomAddress.set("readonly", false);
            this.inputCateringOccasion.set("readonly", false);
            domClass.remove(this.inputCateringOccasionOther, "w3-disabled");
        }

    }

    getDefaultUserDataValues() {

        var url = window.appRoot + "CateringBooking/GetDefaultUserDataJSON";

        this.RequestManager.post(
            url,
            null,
            lang.hitch(this, "_onGetDefaultUserDataValuesResponse"),
            lang.hitch(this, "_onGetDefaultUserDataValuesError"),
            false // sync
        );
    }

    _onGetDefaultUserDataValuesResponse(response: any) {

        if (typeof (response) == "string") {
            this.jsonEntity = JSON.parse(response);
        } else if (typeof (response) == "object") {
            this.jsonEntity = response;
        }

        if (this.bookingEntity === null) {
            this.inputPersonOrderingPhone.defaultValue = response.Telephone;
            this.inputPersonOrderingMail.defaultValue = response.Email;
            this.inputPersonOrdering.defaultValue = response.dispname;
            this.readonlyBookerCostCenter.defaultValue = response.ref_cost_center.dispname;

            this.StandbyStop();
        }
    }

    _showHideBookingAddressInputs(value: any) {

        if (value === "ownRoom") {

            domClass.add(this.inputBookingBookedRoomAddressContainer, "w3-hide");
            domClass.remove(this.inputBookingOwnRoomAddressContainer, "w3-hide");
        } else if (value === "bookedRoom") {

            domClass.add(this.inputBookingOwnRoomAddressContainer, "w3-hide");
            domClass.remove(this.inputBookingBookedRoomAddressContainer, "w3-hide");
        }
    }

    //#### EVENTS
    _onChangeInputCateringData(evt: any) {
        domClass.replace(evt.target, "mds-bg-light-gray", "w3-pale-red");

        this.serializeData();
    }
    _onChangeInputPersonAmountData(evt: any) {
        domClass.replace(evt.target, "mds-bg-light-gray", "w3-pale-red");

        this.validatePersonAmount();

        this.serializeData();
    }
    _onChangeInputCateringTimeData(evt: any) {

        domClass.replace(evt.target, "mds-bg-light-gray", "w3-pale-red");
        this.serializeData();

        this.FilterCateringPackagesByTime();
    }

    _onChangeOrderLocation(selectedLocation: any) {
        console.debug("SELECTED VALUE", selectedLocation);
        //this.inputBookingBookedRoomAddress.searchParam = "";                // name des Parameters im Filter ( => pit-Filter)
        this.inputBookingBookedRoomAddress.requestUrlParameter = "jsonParameters";        // parametername für Extraparameter, der vom Controller erwartet wird
        this.inputBookingBookedRoomAddress.requestUrlParameterValue = selectedLocation.ID;   // wert des Extraparameters

        this.inputBookingBookedRoomAddress.selectedValue = null;
        this.inputBookingBookedRoomAddress._adjustCurrentSelectionState();
        this.inputBookingBookedRoomAddress._loadListValues();



        this.serializeData();
    }
    _onChangeBookedRoomAddress(selectedValue: any) {

        //room info
        this.infoBookedRoomAddress_MaxPersons.innerHTML = this.translations["CateringBooking_HTML_Label_BookedRoomInfo_PersonsAmount"]
            + " " + selectedValue.quantity_persons_min + "-" + selectedValue.quantity_persons_max;

        this.infoBookedRoomAddress_Cost.innerHTML = this.translations["CateringBooking_HTML_Label_BookedRoomInfo_Cost"]
            + " " + this.translations["CateringBooking_HTML_Label_BookedRoomInfo_HalfCost"] + " " + selectedValue.amount_per_half_day + " € | "
            + this.translations["CateringBooking_HTML_Label_BookedRoomInfo_FullCost"] + " " + selectedValue.amount_per_day + " €";

        domClass.remove(this.infoBookedRoomAddress, "w3-hide");
        domClass.remove(this.inputBookingBookedRoomAddressContainer, "w3-margin-bottom");

        //Set new person limit
        this.inputPersonAmount.min = selectedValue.quantity_persons_min;
        this.inputPersonAmount.max = selectedValue.quantity_persons_max;

        this.validatePersonAmount();

        this.serializeData();
        this.ShowHideBookingRoomMessage();
    }
    _onChangeCateringOccasion(selectedValue: any) {

        console.debug("Occasion", selectedValue);
        if (selectedValue.is_with_free_text === true) {
            domClass.remove(this.cateringOccasionOtherContainer, "w3-hide");
        } else {
            domClass.add(this.cateringOccasionOtherContainer, "w3-hide");
        }
        this.serializeData();
    }

    _onChangeBookingTemplate(selectedValue: any) {

        this.cateringPackagesData.forEach(x => x.isSelected = false);

        this.CreateAndFillBookingEntity(JSON.parse(selectedValue.template_json), true);

        domClass.remove(this.resetTemplateBtnContainer, "w3-disabled w3-hide");
    }

    _onClick_ResetTemplateBtn() {

        //domClass.add(this.resetTemplateBtnContainer, "w3-disabled w3-hide");

        //this.inputCateringBookingTemplate._setValueAttr(null);
        //this.inputCateringBookingTemplate._adjustCurrentSelectionState();

        this.emit("RefreshCateringForm");
    }

    _onChangeCateringSaveAsTemplateCheckbox(evt: any) {

        this.saveAsTemplate = evt.target.checked;
        if (this.saveAsTemplate === true) {
            domClass.remove(this.inputCateringTemplateName, "w3-hide");
        } else {
            domClass.add(this.inputCateringTemplateName, "w3-hide");
        }
    }

    _onChangePackageCounter(pkg: any, counter: any) {

        pkg.quantity = parseInt(counter.value);

        domClass.replace(counter, "mediumBrightTransparentBG", "w3-pale-red");

        this.serializeData();
    }

    _onChangeCateringBookingAddressCheck(checkbox: any) {

        domClass.add(this.infoBookedRoomAddress, "w3-hide");
        domClass.add(this.inputBookingBookedRoomAddressContainer, "w3-margin-bottom");

        if (this.inputBookingBookedRoomAddress.selectedValue) {
            console.debug(this.inputBookingBookedRoomAddress);
            this.inputBookingBookedRoomAddress._setValueAttr(null, true);

            //set default personLimit
            this.inputPersonAmount.min = "1";
            this.inputPersonAmount.max = "100";
        }

        this._showHideBookingAddressInputs(checkbox.target.value);

        this.valueBookingAddress = checkbox.target.value;
        domClass.add(this.checkboxInfoLabel, "w3-hide");

        this.serializeData();
        this.ShowHideBookingRoomMessage();
    }

    //_onChangeCateringBookingCoverCheck: function (checkbox) {

    //    this.valueCoverCheck = checkbox.target.value;
    //    this.serializeData();
    //},

    _onChangeInputCostCenter(selectedValue: any) {

        console.debug("HINTBOX SEL VAL", selectedValue, this.inputCostCenre);
        this.serializeData();
    }

    _onSelect_CateringPackages(selectedValues: any) {

        let packageIds = this.cateringPackagesMusliSelect._selectedValues.concat(this.cateringPackagesMusliSelectSingle._selectedValues);

        //this.cateringPackagesData.forEach(x => x.isSelected = false);

        this.drawPackagesTable(packageIds);
        this.serializeData();
    }

    _onClickDeleteTableButton(tr: any, pkg: any) {

        domConstruct.destroy(tr);
        pkg.isSelected = false;

        //if (this.filteredCateringPackagesData.length === 0)
        this.FilterCateringPackagesByTime();

        this.cateringPackagesMusliSelect.buildListValues(this.filteredCateringPackagesData,
            this.cateringPackagesMusliSelect._selectedValues.filter(x => x !== pkg.packageId));

        this.serializeData();
    }

    _onKeyDown_inputPersonAmount(evt: any) {

        if (evt.key.length === 1 && /\D/.test(evt.key)) {
            evt.preventDefault();
        }
    }

    _onClick_SubmitBooking() {

        if (this.checkMandatoryFields()) {

            this.SaveCateringBooking(this.formData);
        }
    }

    _onClick_StartEditBooking() {

        if (this.inputCateringBookingDate.valueAsNumber - Date.now() < 1000 * 60 * 60 * 24 * 7) {

            this.cateringInfoMessageContainer.innerHTML = this.translations["CateringBooking_HTML_Info_Editing"] + "<br>" + this.translations["CateringBooking_HTML_Info_Contact"];
            domClass.remove(this.cateringInfoMessageContainer, "w3-hide");
            domClass.add(this.btn_startEdit, "w3-disabled");
        } else {

            this._setReadonlyAttr(false);
            //if (this.inputCateringBookingDate.valueAsNumber - Date.now() < 1000 * 60 * 60 * 24 * 5) {
            //    domClass.add(this.inputCateringBookingDate, "w3-disabled");
            //    domClass.add(this.inputCateringBookingTimeStart, "w3-disabled");
            //    domClass.add(this.inputCateringBookingTimeEnd, "w3-disabled");
            //}

            this.serializeData();

            domClass.add(this.btn_startEdit, "w3-disabled");
            domClass.remove(this.btn_cancelBooking, "w3-disabled");
        }
    }

    _onClick_StartCancelBooking() {

        if (this.inputCateringBookingDate.valueAsNumber - Date.now() < 1000 * 60 * 60 * 24 * 5) {

            this.cateringInfoMessageContainer.innerHTML = this.translations["CateringBooking_HTML_Info_Cancellation"] + "<br>" + this.translations["CateringBooking_HTML_Info_Contact"];
            domClass.remove(this.cateringInfoMessageContainer, "w3-hide");

            domClass.add(this.btn_cancelBooking, "w3-disabled");
        } else {
            console.debug(this.bookingEntity.bookingId);

            this.CancellCateringBooking(this.bookingEntity.bookingId);
        }

    }

    _onClick_CloseBooking() {

        this.emit("CloseCateringForm");
    }

    _onKeyUpCoNumber(evt: any) {

        if (!isFinite(evt.key) || evt.key === " ") {

            this.inputCoNumber.value = this.inputCoNumber.value.replace(/\D/g, '');
        }
    }

    ShowHideBookingRoomMessage() {

        if (this.formData.addressCheckValue === "ownRoom") {

            domClass.remove(this.cateringRoomInfoMessageContainer, "w3-hide");
        } else if (this.formData.addressCheckValue === "bookedRoom") {

            if (this.inputBookingBookedRoomAddress.selectedEntity && this.inputBookingBookedRoomAddress.selectedEntity.is_without_transport_fee === true) {

                domClass.add(this.cateringRoomInfoMessageContainer, "w3-hide");
            } else if (this.inputBookingBookedRoomAddress.selectedEntity == null) {

                domClass.add(this.cateringRoomInfoMessageContainer, "w3-hide");
            } else {

                domClass.remove(this.cateringRoomInfoMessageContainer, "w3-hide");
            }
        }
    }

    isDateValid() {

        !this.inputCateringBookingDate.value ? domClass.replace(this.inputCateringBookingDate, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputCateringBookingDate, "mds-bg-light-gray", "w3-pale-red");

        let inputDate = new Date(this.inputCateringBookingDate.value);
        let difference = dojoDate.difference(new Date(), inputDate, "day");

        //console.debug("difference in dates", difference);

        if (difference < 2 || difference > 182500 || isNaN(difference)) return false;

        return true;
    }

    isTimeValid() {

        !this.inputCateringBookingDate.value ? domClass.replace(this.inputCateringBookingDate, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputCateringBookingDate, "mds-bg-light-gray", "w3-pale-red");

        if (!this.inputCateringBookingTimeStart.value) domClass.replace(this.inputCateringBookingTimeStart, "w3-pale-red", "mds-bg-light-gray");
        if (!this.inputCateringBookingTimeEnd.value) domClass.replace(this.inputCateringBookingTimeEnd, "w3-pale-red", "mds-bg-light-gray");

        let borderStart = "06:00";
        let borderEnd = "22:00";

        if (this.inputCateringBookingTimeStart.value < borderStart) return false;
        if (this.inputCateringBookingTimeEnd.value > borderEnd) return false;
        if (this.inputCateringBookingTimeStart.value > this.inputCateringBookingTimeEnd.value) return false;

        let timeStart = new Date('1970-01-01T' + this.inputCateringBookingTimeStart.value + ':00Z');
        let timeEnd = new Date('1970-01-01T' + this.inputCateringBookingTimeEnd.value + ':00Z');

        if (timeEnd.getTime() - timeStart.getTime() < 1 * 60 * 60 * 1000) return false;

        return true;
    }

    validatePersonAmount() {
        let val = parseInt(this.inputPersonAmount.value);
        let min = parseInt(this.inputPersonAmount.min);
        let max = parseInt(this.inputPersonAmount.max);

        if (val < min || val > max) {

            if (val < min) this.inputPersonAmount.value = this.inputPersonAmount.min;
            if (val > max) this.inputPersonAmount.value = this.inputPersonAmount.max;

            let interval = setInterval(() => {
                if (domClass.contains(this.inputPersonAmount, "w3-pale-red")) {
                    domClass.replace(this.inputPersonAmount, "mds-bg-light-gray", "w3-pale-red");
                } else {
                    domClass.replace(this.inputPersonAmount, "w3-pale-red", "mds-bg-light-gray");
                }
            }, 150);

            setTimeout(() => {
                clearInterval(interval);
                domClass.replace(this.inputPersonAmount, "mds-bg-light-gray", "w3-pale-red");
            }, 1500);
        }
    }

    serializeData() {
        this.formData.isNewBooking = this.bookingEntity === null || this.isFromTemplate === true;

        this.formData.telephone = this.inputPersonOrderingPhone.value;
        this.formData.email = this.inputPersonOrderingMail.value;
        this.inputCostCenre.selectedEntity ? this.formData.costCenter = this.inputCostCenre.selectedEntity.ID : this.formData.costCenter = null;
        this.formData.coNumber = this.inputCoNumber.value;
        this.formData.orderLocationCatering = this.inputOrderLocation.selectedValue;

        this.formData.addressCheckValue = this.valueBookingAddress;
        this.formData.ownBookingAddress = this.inputBookingOwnRoomAddress.value;
        this.formData.bookedRoomAddress = this.inputBookingBookedRoomAddress.selectedValue;

        this.formData.personAmount = parseInt(this.inputPersonAmount.value);

        /*this.formData.coverCheckValue = this.valueCoverCheck;*/

        this.formData.cateringOccasion = this.inputCateringOccasion.selectedValue;
        if (this.inputCateringOccasion.selectedEntity !== null && this.inputCateringOccasion.selectedEntity.is_with_free_text === true) {

            this.formData.cateringOccasionOther = this.inputCateringOccasionOther.value;
        } else {

            this.formData.cateringOccasionOther = "";
        }

        this.formData.bookingDate = this.inputCateringBookingDate.value;
        this.formData.bookingTimeStart = this.inputCateringBookingTimeStart.value;
        this.formData.bookingTimeEnd = this.inputCateringBookingTimeEnd.value;

        this.formData.cateringPackages = this.cateringPackagesData.filter(x => x.isSelected === true);

        this.formData.specialRequest = this.inputSpecialRequest.value;

        console.debug("FORM DATA", this.formData);

        let isDateValid = this.isDateValid();
        let isTimeValid = this.isTimeValid();

        if (isDateValid === true && isTimeValid === true) {

            this.showErrorMsg(false);
            domClass.replace(this.inputCateringBookingDate, "mds-bg-light-gray", "w3-pale-red");
            domClass.replace(this.inputCateringBookingTimeStart, "mds-bg-light-gray", "w3-pale-red");
            domClass.replace(this.inputCateringBookingTimeEnd, "mds-bg-light-gray", "w3-pale-red");

            if (!this.formData.isNewBooking) {

                this.set("isDirty", this._formDataUndirty !== JSON.stringify(this.formData));

                console.debug("IS DIRTY", this.isDirty);

                if (!this.readonly) {

                    this.isDirty ? domClass.remove(this.btn_submitBooking, "w3-disabled") : domClass.add(this.btn_submitBooking, "w3-disabled");
                }
            } else {

                domClass.remove(this.btn_submitBooking, "w3-disabled");
            }
        } else {

            let message = "error";
            if (isDateValid === false && isTimeValid === false) message = this.translations["CateringBooking_Form_DateErrorMessage"] + " / " + this.translations["CateringBooking_Form_TimeErrorMessage"];
            if (isDateValid === false && isTimeValid === true) message = this.translations["CateringBooking_Form_DateErrorMessage"];
            if (isDateValid === true && isTimeValid === false) message = this.translations["CateringBooking_Form_TimeErrorMessage"];

            if (!this.readonly && this.inputCateringBookingDate.value && this.inputCateringBookingTimeStart.value && this.inputCateringBookingTimeEnd.value) {

                if (isDateValid === false) {

                    domClass.replace(this.inputCateringBookingDate, "w3-pale-red", "mds-bg-light-gray");
                }
                if (isTimeValid === false) {

                    domClass.replace(this.inputCateringBookingTimeStart, "w3-pale-red", "mds-bg-light-gray");
                    domClass.replace(this.inputCateringBookingTimeEnd, "w3-pale-red", "mds-bg-light-gray");
                }

                this.showErrorMsg(true, message);
                domClass.add(this.btn_submitBooking, "w3-disabled");
            }
        }

        //    if (this.isTimeValid()) {

        //        this.showErrorMsg(false);
        //        domClass.replace(this.inputCateringBookingTimeStart, "mds-bg-light-gray", "w3-pale-red");
        //        domClass.replace(this.inputCateringBookingTimeEnd, "mds-bg-light-gray", "w3-pale-red");

        //        if (!this.formData.isNewBooking) {

        //            this.set("isDirty", this._formDataUndirty !== JSON.stringify(this.formData));

        //            console.debug("IS DIRTY", this.isDirty);

        //            if (!this.readonly) {

        //                this.isDirty ? domClass.remove(this.btn_submitBooking, "w3-disabled") : domClass.add(this.btn_submitBooking, "w3-disabled");
        //            }
        //        } else {

        //            domClass.remove(this.btn_submitBooking, "w3-disabled");
        //        }
        //    } else {
        //        if (this.inputCateringBookingTimeStart.value && this.inputCateringBookingTimeEnd.value) {

        //            domClass.replace(this.inputCateringBookingTimeStart, "w3-pale-red", "mds-bg-light-gray");
        //            domClass.replace(this.inputCateringBookingTimeEnd, "w3-pale-red", "mds-bg-light-gray");

        //            this.showErrorMsg(true, this.translations["CateringBooking_Form_TimeErrorMessage"]);
        //            domClass.add(this.btn_submitBooking, "w3-disabled");
        //        }
        //    }
    }

    //serializeData: function (resetDirtyState, bypassReadonly) {

    //    if (this._serializeDataHandle != null) {
    //        clearTimeout(this._serializeDataHandle);
    //        this._serializeDataHandle = null;
    //    }
    //    //dateOfRecord wird einmal direkt gesetzt und kann/darf sich nicht ändern
    //    //selbiges für reporterID - UPDATE: Reporter ist änderbar

    //    var entity = this.inputCateringBookingType.get("selectedEntity");
    //    this.formData = { /* TODO!! */ };

    //    if (resetDirtyState === true) {
    //        this._formDataUndirty = JSON.stringify(this.formData)
    //        //console.log("reset dirtystate", this._formDataUndirty);
    //    }

    //    console.log("serializeData", this.formData, "readonly?", this.readonly);

    //    if (this.readonly == true && bypassReadonly !== true) { // nicht weitermachen wenns schreibgeschützt ist!
    //        return;
    //    }

    //    if (this._formDataUndirty != null) {
    //        this.set("IsDirty", this._formDataUndirty != JSON.stringify(this.formData));
    //    } else {
    //        this.set("IsDirty", this._formDataUndirty == null && this.formData != null);
    //    }

    //    this.checkMandatoryFields();
    //},

    checkMandatoryFields() {

        let addressCheck = true;
        let packagesCheck = true;
        let occasionCheck = true;
        let coNummerCheck = true;
        //if (!this.formData.telephone) {
        //    domClass.replace(this.inputPersonOrderingPhone, "w3-pale-red", "mds-bg-light-gray")
        //} else {
        //    domClass.replace(this.inputPersonOrderingPhone, "mds-bg-light-gray", "w3-pale-red")
        //}
        !this.formData.telephone ? domClass.replace(this.inputPersonOrderingPhone, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputPersonOrderingPhone, "mds-bg-light-gray", "w3-pale-red");
        !this.formData.email ? domClass.replace(this.inputPersonOrderingMail, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputPersonOrderingMail, "mds-bg-light-gray", "w3-pale-red");
        !this.formData.orderLocationCatering ? domClass.replace(this.inputOrderLocation, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputOrderLocation, "mds-bg-light-gray", "w3-pale-red");

        if (this.formData.addressCheckValue === "ownRoom") {

            if (!this.formData.ownBookingAddress) {
                domClass.replace(this.inputBookingOwnRoomAddress, "w3-pale-red", "mds-bg-light-gray")
                addressCheck = false;
            } else {
                domClass.replace(this.inputBookingOwnRoomAddress, "mds-bg-light-gray", "w3-pale-red");
                addressCheck = true;
            }
        } else if (this.formData.addressCheckValue === "bookedRoom") {

            if (!this.formData.bookedRoomAddress) {
                domClass.replace(this.inputBookingBookedRoomAddress, "w3-pale-red", "mds-bg-light-gray");
                addressCheck = false;
            } else {
                domClass.replace(this.inputBookingBookedRoomAddress, "mds-bg-light-gray", "w3-pale-red");
                addressCheck = true;
            }
        } else {

            domClass.remove(this.checkboxInfoLabel, "w3-hide");
            addressCheck = false;
        }

        !this.formData.personAmount ? domClass.replace(this.inputPersonAmount, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputPersonAmount, "mds-bg-light-gray", "w3-pale-red");
        !this.formData.cateringOccasion ? domClass.replace(this.inputCateringOccasion, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputCateringOccasion, "mds-bg-light-gray", "w3-pale-red");
        if (this.inputCateringOccasion.selectedEntity !== null && this.inputCateringOccasion.selectedEntity.is_with_free_text === true) {

            !this.formData.cateringOccasionOther ? domClass.replace(this.inputCateringOccasionOther, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputCateringOccasionOther, "mds-bg-light-gray", "w3-pale-red");
        }

        !this.formData.bookingDate ? domClass.replace(this.inputCateringBookingDate, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputCateringBookingDate, "mds-bg-light-gray", "w3-pale-red");
        !this.formData.bookingTimeStart ? domClass.replace(this.inputCateringBookingTimeStart, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputCateringBookingTimeStart, "mds-bg-light-gray", "w3-pale-red");
        !this.formData.bookingTimeEnd ? domClass.replace(this.inputCateringBookingTimeEnd, "w3-pale-red", "mds-bg-light-gray") : domClass.replace(this.inputCateringBookingTimeEnd, "mds-bg-light-gray", "w3-pale-red");

        if (this.formData.cateringPackages.length === 0) {

            domClass.add(this.inputCateringPackagesList, "w3-pale-red");
        } else {

            domClass.remove(this.inputCateringPackagesList, "w3-pale-red");

            this.cateringPackagesTableContainer.firstChild.childNodes.forEach(tr => {
                if (tr.childNodes[1].firstChild.value == 0) {

                    domClass.replace(tr.childNodes[1].firstChild, "w3-pale-red", "mediumBrightTransparentBG");
                    packagesCheck = false;
                }
            });
        }

        if (this.formData.coNumber) {

            if (this.formData.coNumber.length < 9) {

                domClass.replace(this.inputCoNumber, "w3-pale-red", "mds-bg-light-gray");
                //domClass.replace(this.inputCoNumber, "mds-bg-light-gray", "w3-pale-red");
                coNummerCheck = false;
            }
        }

        if (!this.formData.telephone || !this.formData.email || !this.formData.orderLocationCatering || !addressCheck
            || !this.formData.personAmount || !this.formData.cateringOccasion || !occasionCheck || !this.formData.bookingDate
            || !this.formData.bookingTimeStart || !this.formData.bookingTimeEnd
            || this.formData.cateringPackages.length === 0 || !packagesCheck || !coNummerCheck) {

            domClass.add(this.btn_submitBooking, "w3-disabled");
            this.showErrorMsg(true, this.translations["CateringBooking_Form_DataErrorMessage"]);

            return false;
        } else {
            return true;
        }
    }

    loadCateringBooking(entityGUID: any) {

        var url = window.appRoot + "CateringBooking/GetBookingDetails";

        if (entityGUID != null && typeof (entityGUID) != "undefined") {
            this.entityGUID = entityGUID;
        }

        var entityGUID = this.entityGUID;

        this.RequestManager.post(
            url,
            {
                GUID: entityGUID
            },
            lang.hitch(this, "_onLoadCateringBookingResponse"),
            lang.hitch(this, "_onLoadCateringBookingError"),
            false // sync
        );
    }

    _onLoadCateringBookingResponse(response: any, bVirtual?: any) {

        if (typeof (response) == "string") {
            this.jsonEntity = JSON.parse(response);
        } else if (typeof (response) == "object") {
            this.jsonEntity = response;
        }

        if (this.jsonEntity == null || typeof (this.jsonEntity) == "undefined") {
            this.StandbyStop();
            alert("requested item does not exist");
            return;
        }

        this.emit("EntityChange", this.jsonEntity);

        console.debug("_onLoadCateringBookingResponse", this.jsonEntity);

        this.CreateAndFillBookingEntity(this.jsonEntity);
    }

    drawPackagesTable(packageIds: any) {

        domConstruct.empty(this.cateringPackagesTableContainer);

        if (packageIds.length > 0) {
            let table = domConstruct.create("table", { class: "w3-table-all" }, this.cateringPackagesTableContainer);
            domClass.remove(this.inputCateringPackagesList, "w3-pale-red");

            packageIds.forEach(id => {

                let pkg = this.cateringPackagesData.filter(x => x.packageId === id)[0];
                pkg.isSelected = true;

                let tr = domConstruct.create("tr", {}, table);

                let labelTd = domConstruct.create("td", { innerHTML: pkg.label, class: "w3-half w3-padding w3-hover-text-indigo w3-dropdown-hover" }, tr);
                domStyle.set(labelTd, "background-color", "#ccc0");

                domConstruct.create("div", {
                    class: "w3-dropdown-content w3-bar-block w3-border w3-padding-small w3-border-indigo w3-pale-yellow",
                    innerHTML: pkg.packageDetails,
                    style: "pointer-events: none;"
                }, labelTd);

                if (pkg.quantity === 0 && parseInt(this.inputPersonAmount.value) > 0) {
                    pkg.quantity = parseInt(this.inputPersonAmount.value);
                }


                let quantityTd = domConstruct.create("td", { class: "w3-quarter w3-padding" }, tr);
                let counter = domConstruct.create("input", {
                    id: pkg.packageId,
                    class: "w3-border round mediumBrightTransparentBG w3-input w3-padding-small w3-border-gray",
                    type: "number",
                    step: "1",
                    min: "0",
                    value: pkg.quantity
                }, quantityTd);

                on(counter, "change", lang.hitch(this, this._onChangePackageCounter, pkg, counter));

                domConstruct.create("td", { innerHTML: `€ ${pkg.priceUnit.toFixed(2)}/${pkg.unit}`, class: "w3-quarter w3-padding" }, tr);

                let btnTd = domConstruct.create("td", { class: "w3-padding" }, tr);
                let deleteBtn = domConstruct.create("button", {
                    innerHTML: `<i class="fas fa-times"></i>`,
                    class: "mds-button-base mds-hover-dark w3-pale-red"
                }, btnTd);

                on(deleteBtn, "click", lang.hitch(this, this._onClickDeleteTableButton, tr, pkg));
            })

            domClass.remove(this.cateringPackagesTableContainer, "w3-hide");
        } else {
            domClass.add(this.cateringPackagesTableContainer, "w3-hide");
        }
    }

    buildCateringPackagesRegistry(jsonArray: any) {

        this.cateringPackagesData = [];

        jsonArray.forEach(pkg => {
            let pseudoEntry = {
                isSelected: false,
                packageId: pkg.ID,
                label: "",
                isPackage: pkg.is_package,
                unit: pkg.ref_unit.Name,
                priceUnit: pkg.price_unit,
                quantity: 0,
                selectionID: null,
                timeOfDay: {
                    time_start: pkg.ref_time_of_day.time_start_a,
                    time_end: pkg.ref_time_of_day.time_end_a
                },
                packageDetails: pkg.tmp_package_details
            }

            pseudoEntry.isPackage === true ? pseudoEntry.label = pkg.dispname : pseudoEntry.label = pkg.description;

            this.cateringPackagesData.push(pseudoEntry);
        });
    }

    FilterCateringPackagesByTime() {

        if (this.isTimeValid()) {

            domClass.remove(this.sectionCateringPackages, "w3-disabled");

            this.filteredCateringPackagesData = this.cateringPackagesData.filter(x => x.timeOfDay.time_end >= this.formData.bookingTimeStart && x.timeOfDay.time_start <= this.formData.bookingTimeEnd);

            this.cateringPackagesData
                .forEach(pack => {
                    let filter = this.filteredCateringPackagesData.filter(x => x.packageId === pack.packageId);
                    if (filter.length > 0) {
                        pack.isSelected = filter[0].isSelected;
                    } else {
                        pack.isSelected = false;
                    }
                });

            //pack.isSelected = this.filteredCateringPackagesData.filter(x => x.ID === pack.ID)[0].isSelected
            this.BuildCateringPackagesMultiselect(this.filteredCateringPackagesData);
        } else {

            domClass.add(this.sectionCateringPackages, "w3-disabled");
        }

        this.serializeData();
    }

    CancellCateringBooking(bookingId: any) {

        var url = window.appRoot + "CateringBooking/CancellCateringBooking";

        this.RequestManager.post(
            url, {
                bookingId: bookingId
            },
            lang.hitch(this, "_CancellCateringBookingResponse"),
            lang.hitch(this, "_CancellCateringBookingError"),
            false // sync
        );
    }

    _CancellCateringBookingResponse(response: any) {

        if (typeof (response) == "string") {
            this.jsonEntity = JSON.parse(response);
        } else if (typeof (response) == "object") {
            this.jsonEntity = response;
        }

        let saveDlg = new GenericDialog();
        saveDlg._setTopCloseBtnAttr(true);
        saveDlg._setHeaderAttr(this.translations["CateringBooking_Form_CancellBookingPopup_Header"]);
        saveDlg.hideSubtitleNode(true);
        saveDlg.set("ok", true);
        saveDlg._setContentAttr(this.translations["CateringBooking_Form_CancellBookingPopup_Message"]);

        domStyle.set(saveDlg.textNode, "height", "unset");
        domStyle.set(saveDlg.textNode.parentNode as any, "width", "600px");
        domStyle.set(saveDlg.textNode.parentNode as any, "margin-top", "150px");

        saveDlg.show();

        this.emit("CloseCateringForm");
        this.destroy();
    }

    _loadCateringPackagesList() {

        var url = window.appRoot + "CateringBooking/GetCateringPackageListJSON";

        this.RequestManager.post(
            url,
            null,
            lang.hitch(this, "_loadCateringPackagesListResponse"),
            lang.hitch(this, "_loadCateringPackagesListError"),
            false // sync
        );
    }

    _loadCateringPackagesListResponse(response: any) {

        if (typeof (response) == "string") {
            this.jsonEntity = JSON.parse(response);
        } else if (typeof (response) == "object") {
            this.jsonEntity = response;
        }

        this.buildCateringPackagesRegistry(response);

        this.BuildCateringPackagesMultiselect(this.cateringPackagesData);

        this.emit("CateringPackagesReady");
    }

    BuildCateringPackagesMultiselect(packagesList: any) {
        domConstruct.empty(this.inputCateringPackagesList);

        this.cateringPackagesMusliSelect = new MultiSelect;
        this.cateringPackagesMusliSelectSingle = new MultiSelect;

        this.cateringPackagesMusliSelect.set("labelAttribute", "label");
        this.cateringPackagesMusliSelect.set("valueAttribute", "packageId");
        this.cateringPackagesMusliSelect.set("entities", packagesList.filter(x => x.isPackage === true));
        this.cateringPackagesMusliSelect._constructOptions();

        this.cateringPackagesMusliSelectSingle.set("labelAttribute", "label");
        this.cateringPackagesMusliSelectSingle.set("valueAttribute", "packageId");
        this.cateringPackagesMusliSelectSingle.set("entities", packagesList.filter(x => x.isPackage === false));
        this.cateringPackagesMusliSelectSingle._constructOptions();

        this.cateringPackagesMusliSelect.set("selectablesWithDropdown", true);
        this.cateringPackagesMusliSelect.set("dropdownAttributeName", "packageDetails");

        //this.cateringPackagesMusliSelectSingle.set("selectablesWithDropdown", true);
        //this.cateringPackagesMusliSelectSingle.set("dropdownAttributeName", "packageDetails");

        domConstruct.create("h5", {
            class: "",
            innerHTML: this.translations["CateringBooking_HTML_Label_PackagesList"]
        }, this.inputCateringPackagesList);

        domConstruct.place(this.cateringPackagesMusliSelect.domNode, this.inputCateringPackagesList);

        domConstruct.create("h5", {
            class: "",
            innerHTML: this.translations["CateringBooking_Label_SingleProducts"]
        }, this.inputCateringPackagesList);

        domConstruct.place(this.cateringPackagesMusliSelectSingle.domNode, this.inputCateringPackagesList);

        let selectedList_Pack = packagesList.filter(x => x.isPackage === true && x.isSelected === true);
        let packageIds_Pack = [];
        let selectedList_Single = packagesList.filter(x => x.isPackage === false && x.isSelected === true);
        let packageIds_Single = [];

        console.debug("SELECTED LIST pack", selectedList_Pack);
        console.debug("SELECTED LIST single", selectedList_Single);

        if (selectedList_Pack.length > 0) {
            selectedList_Pack.forEach(x => packageIds_Pack.push(x.packageId));
        }
        if (selectedList_Single.length > 0) {
            selectedList_Single.forEach(x => packageIds_Single.push(x.packageId));
        }

        //setTimeout(this.drawPackagesTable(packageIds), 2500)
        let packageIds = packageIds_Pack.concat(packageIds_Single);
        this.drawPackagesTable(packageIds);
        this.cateringPackagesMusliSelect.buildListValues(packagesList.filter(x => x.isPackage === true), packageIds);
        this.cateringPackagesMusliSelectSingle.buildListValues(packagesList.filter(x => x.isPackage === false), packageIds);

        on(this.cateringPackagesMusliSelect, "change", lang.hitch(this, this._onSelect_CateringPackages));
        on(this.cateringPackagesMusliSelectSingle, "change", lang.hitch(this, this._onSelect_CateringPackages));

        this.serializeData();
    }

    //DrawMultiSelectInfoDropdown: function () {

    //    this.cateringPackagesMusliSelect.optionsRegistry.forEach(option => {

    //        let details = option.entity["packageDetails"];
    //        let hoverNode = option.optionNode.lastChild;
    //        domClass.add(hoverNode, "w3-dropdown-hover");
    //        domConstruct.create("div", {
    //            class: "w3-dropdown-content w3-bar-block w3-border w3-padding-small w3-border-indigo w3-pale-yellow",
    //            //style: {
    //            //    "pointerEvents": "none"
    //            //},
    //            innerHTML: details
    //        }, hoverNode);
    //    });
    //},

    CreateAndFillBookingEntity(data: any, isTemplate: any = false) {

        this.bookingEntity = {
            isNewBooking: false,
            bookingId: data.ID,
            telephone: data.Telephone,
            email: data.ref_booker.Email,
            costCenter: null,
            coNumber: "",
            orderLocationCatering: data.ref_location_catering.ID,
            addressCheckValue: null,
            ownBookingAddress: "",//data.own_room,
            bookedRoomAddress: null,//data.ref_vt_service.ID,
            personAmount: data.quantity_persons,
            /*coverCheckValue: null,*/
            cateringOccasion: data.ref_activity_status.ID,
            cateringOccasionOther: "",
            bookingDate: null,
            bookingTimeStart: null,
            bookingTimeEnd: null,
            cateringPackages: [],
            specialRequest: null
        };

        if (isTemplate === true) {
            this.isFromTemplate = true;

            this.bookingEntity.isNewBooking = true;
            this.bookingEntity.bookingId = this.formData.bookingId;
            this.bookingEntity.telephone = this.formData.telephone;
            this.bookingEntity.email = this.formData.email;

            this.bookingEntity.specialRequest = this.formData.specialRequest;

            domClass.remove(this.sectionCateringPackages, "w3-disabled");
        } else {
            this.isFromTemplate = false;

            this.bookingEntity.isNewBooking = false;
            this.bookingEntity.bookingId = data.ID;
            this.bookingEntity.telephone = data.Telephone;
            this.bookingEntity.email = data.ref_booker.Email;

            this.bookingEntity.specialRequest = data.special_request.replace(/\r\n/g, "\n");
            this.inputSpecialRequest.value = this.bookingEntity.specialRequest;

            if (data.ref_cost_center2) this.bookingEntity.costCenter = data.ref_cost_center2.ID;
            //this.inputCostCenre.value = this.bookingEntity.costCenter;
            this.inputCostCenre._setValueAttr(data.ref_cost_center2);

            this.inputPersonOrdering.value = data.ref_booker.dispname;
            this.inputPersonOrderingPhone.value = this.bookingEntity.telephone;
            this.inputPersonOrderingMail.value = this.bookingEntity.email;

            if (data.ref_cost_center)this.readonlyBookerCostCenter.value = data.ref_cost_center.dispname;

            this.inputCoNumber.value = data.co_number;

            this.bookingEntity.bookingDate = data.date_start.split("T")[0];

            this.inputCateringBookingDate.value = this.bookingEntity.bookingDate;
        }

        if (data.free_text_activity_status) this.bookingEntity.cateringOccasionOther = data.free_text_activity_status;

        this.bookingEntity.bookingTimeStart = data.date_start.split("T")[1].slice(0, -3);
        this.bookingEntity.bookingTimeEnd = data.date_end.split("T")[1].slice(0, -3);

        this.inputCateringBookingTimeStart.value = this.bookingEntity.bookingTimeStart;
        this.inputCateringBookingTimeEnd.value = this.bookingEntity.bookingTimeEnd;

        this.formData.bookingId = this.bookingEntity.bookingId;

        this.inputOrderLocation.selectedValue = this.bookingEntity.orderLocationCatering;
        this.inputOrderLocation._adjustCurrentSelectionState();

        if (data.is_own_room === false) {
            this.bookingEntity.addressCheckValue = "bookedRoom";

            this.radioInputBookedRoom.checked = true;

            this.bookingEntity.bookedRoomAddress = data.ref_vt_service.ID;

            this.inputBookingBookedRoomAddress.selectedValue = this.bookingEntity.bookedRoomAddress;
            this.inputBookingBookedRoomAddress._adjustCurrentSelectionState();
        } else {
            this.bookingEntity.addressCheckValue = "ownRoom";

            this.radioInputOwnRoom.checked = true;

            this.bookingEntity.ownBookingAddress = data.own_room;

            this.inputBookingOwnRoomAddress.value = this.bookingEntity.ownBookingAddress;
        }

        //if (data.is_catering === false) {
        //    this.bookingEntity.coverCheckValue = "no";
        //    this.radioInputNo.checked = true;
        //} else {
        //    this.bookingEntity.coverCheckValue = "yes";
        //    this.radioInputYes.checked = true;
        //}

        this.valueBookingAddress = this.bookingEntity.addressCheckValue;
        this._showHideBookingAddressInputs(this.bookingEntity.addressCheckValue);

        this.inputPersonAmount.value = this.bookingEntity.personAmount;

        //this.valueCoverCheck = this.bookingEntity.coverCheckValue;

        this.inputCateringOccasion.selectedValue = this.bookingEntity.cateringOccasion;
        this.inputCateringOccasion._adjustCurrentSelectionState();
        this.inputCateringOccasionOther.value = this.bookingEntity.cateringOccasionOther;

        let packageIds = [];

        data.cateringPackages.forEach(x => {

            let pkg = this.cateringPackagesData.filter(y => y.packageId === x.ref_vt_service.ID)[0];

            pkg.isSelected = true;
            pkg.quantity = x.quantity;
            pkg.selectionID = x.ID;

            packageIds.push(pkg.packageId);
        });

        this.bookingEntity.cateringPackages = this.cateringPackagesData.filter(x => x.isSelected === true);

        this.drawPackagesTable(packageIds);

        this.cateringPackagesMusliSelect.buildListValues(this.cateringPackagesData, packageIds);

        if (isTemplate === false) {

            if (Date.now() < this.inputCateringBookingDate.valueAsNumber) {

                domClass.remove(this.btn_startEdit, "w3-hide");
                domClass.remove(this.btn_cancelBooking, "w3-hide");
            }

            this._formDataUndirty = JSON.stringify(this.bookingEntity);

            console.debug("UnDirty: ", this._formDataUndirty);
            this.FilterCateringPackagesByTime();
            domClass.add(this.sectionCateringPackages, "w3-disabled");
        } else {
            this.FilterCateringPackagesByTime();
        }

        if (data.isBookingCancelled === true) {
            domClass.add(this.btn_startEdit, "w3-hide");
            domClass.add(this.btn_cancelBooking, "w3-hide");
            domClass.add(this.btn_submitBooking, "w3-hide");

            this.cateringInfoMessageContainer.innerHTML = this.translations["CateringBooking_HTML_Info_BookingIsCancelled"];
            domClass.remove(this.cateringInfoMessageContainer, "w3-hide");
        }

        this.serializeData();
        this.StandbyStop();
    }

    SaveCateringBooking(data: any) {
        this.StandbyStart();

        data.cateringPackages.forEach(x => x.packageDetails = "");

        var url = window.appRoot + "CateringBooking/SaveCateringBookingData";

        let template = null;
        if (this.saveAsTemplate === true) {

            template = {
                saveAsTemplate: this.saveAsTemplate,
                name: this.inputCateringTemplateName.value
            };
        }

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data),
                templateData: JSON.stringify(template)
            },
            lang.hitch(this, "_saveCateringBookingResponse"),
            lang.hitch(this, "_saveCateringBookingError"),
            false // sync
        );
    }

    _saveCateringBookingResponse(response: any) {

        this.StandbyStop();

        let saveDlg = new GenericDialog();
        saveDlg._setTopCloseBtnAttr(true);
        saveDlg._setHeaderAttr(this.translations["CateringBooking_Form_SaveBookingPopup_Header"]);
        saveDlg.hideSubtitleNode(true);
        saveDlg.set("ok", true);
        saveDlg._setContentAttr(this.translations["CateringBooking_Form_SaveBookingPopup_Message"]);

        domStyle.set(saveDlg.textNode, "height", "unset");
        domStyle.set(saveDlg.textNode.parentNode as any, "width", "600px");
        domStyle.set(saveDlg.textNode.parentNode as any, "margin-top", "150px");

        saveDlg.show();

        this.emit("CloseCateringForm");
        this.destroy();
    }

    //ERROR FUNCTIONS
    showErrorMsg(bool: any, msg?: any) {

        if (bool === true) {
            this.errorMsgNode.innerHTML = msg;
        } else {
            this.errorMsgNode.innerHTML = "";
        }
    }

    _saveCateringBookingError(err: any) {
        this.showErrorMsg(true, err.Message);
        this.StandbyStop();
    }

    _loadCateringPackagesListError(err: any) {
        this.showErrorMsg(true, err.Message);
        this.StandbyStop();
    }

    _onLoadCateringBookingError(err: any) {
        this.showErrorMsg(true, err.Message);
        this.StandbyStop();
    }

    _CancellCateringBookingError(err: any) {
        this.showErrorMsg(true, err.Message);
        this.StandbyStop();
    }

    _onGetDefaultUserDataValuesError(err: any) {
        this.showErrorMsg(true, err.Message);
        this.StandbyStop();
    }
}
CateringBookingForm.prototype.declaredClass = 'WidgetCollection.JDM.CateringBooking.CateringBookingForm';

export default mdsWidget(CateringBookingForm);
